import angular from "angular";

angular
    .module('app')
    .component('courseTrainingProgramMobile', {
        template: require('./course-training-program-mobile.html'),
        controller: ['$uibModal', '$http', '$sce', '$timeout', '$interval', 'Notifier', controller],
        bindings: {
            course: '<',
            activeLesson: '<'
        }
    });

function controller(Upload, $uibModal, $http, $sce, $timeout, $interval, Notifier) {

    let $ctrl = this;
    $ctrl.l = null;

    $ctrl.$onInit = function () {
        $ctrl.lesson = $ctrl.activeLesson;
        $timeout(function () {
            $ctrl.lessons = [];
            $ctrl.course.chapters.forEach(function (chapter, chapterInd) {
                chapter.lessons.forEach(function (lesson, lessonInd) {
                    $ctrl.lessons.push(lesson);
                    lesson.pTitle = (chapterInd + 1) + '.' + (lessonInd + 1) + ' ' + lesson.title;
                    // if (lesson.id === $ctrl.lesson.id) {
                    //     chapter.open = true;
                    // }
                });
            });
        }, 1000);
    };

    $ctrl.goToLesson = function () {
        if ($ctrl.l) {
            window.location = `/cabinet/courses/${$ctrl.course.id}/?lesson_id=${$ctrl.l.id}`;
        }
    };

}
